import { setPagination } from '../../../State/pagination';
import fetchCaveats from '../../../Services/fetchCaveats';

export default (pagination) => async (dispatch) => {

  window.scrollTo(0, 0);

  dispatch(setPagination(pagination));
  
  await dispatch(fetchCaveats());

}